import { Box, Divider, Drawer as MUIDrawer, Stack } from '@mui/material';
import styled from 'styled-components';

import { TStyledDrawerProps } from '@/shared/components/ui/drawer-controller/drawer-controller.types';

export const Drawer = styled(MUIDrawer)<TStyledDrawerProps>`
  && {
    z-index: 1300;

    & .MuiBackdrop-root {
      background-color: ${({ theme }) => theme.palette.background.overlay};
    }

    & .MuiDrawer-paper {
      background: ${({ theme }) => theme.palette.background.paper};
      border-top-left-radius: ${({ theme }) => theme.shape.drawerRadius};
      border-bottom-left-radius: ${({ theme }) => theme.shape.drawerRadius};
      padding: ${({ theme }) => theme.spacing(6)};
      width: ${({ $width }) => ($width ? $width : '23.75rem')};
      max-width: 90vw;
      display: flex;
      flex-direction: column;
      top: ${({ $topOffset }) => $topOffset ?? '0px'};
      height: ${({ $topOffset }) =>
        $topOffset ? `calc(100% - ${$topOffset})` : '100%'};
      box-shadow: none;
    }
  }
`;

export const TopContent = styled(Box)`
  && {
    display: flex;
    flex-direction: column;
  }
`;

export const PanelHeader = styled(Box)`
  && {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: ${({ theme }) => theme.spacing(7)};
    gap: 1rem;
  }
`;

export const CustomDivider = styled(Divider)`
  && {
    margin: ${({ theme }) => theme.spacing(5)} 0;
  }
`;

export const ContentStack = styled(Stack)`
  & {
    overflow-y: auto;
    overflow-x: hidden;
  }
`;
